import React, { FC } from 'react';
import useMiniCard from 'hooks/useMiniCard';
import { useStores } from 'hooks/useStores';
import { observer } from 'mobx-react-lite';
import AdvertItemDataModel from 'models/AdvertDataModel/AdvertItemDataModel';
import { MileageStyles } from './MileageStyles';

interface Props {
  item: AdvertItemDataModel;
  className?: string;
}

const Mileage: FC<Props> = observer(({ item }) => {
  const {
    appStore: { isDesktop },
  } = useStores();

  const {
    data: {
      advert: { isSpecialMachinery, isPurchase },
    },
  } = useMiniCard();

  if (!isDesktop) return null;

  const data = isSpecialMachinery ? item.formattedWorkingHours : item.formattedMileage;

  return (
    <MileageStyles>
      {!!data && isPurchase && 'до\u00A0'}
      {data}
    </MileageStyles>
  );
});

export default Mileage;
